
import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Snackbar,
} from "@mui/material";
import { remove, get } from "../../../services/api-services";  

const CancelEnrollment = ({ open, onClose, mainId, onSuccess }) => {
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");

  const handleCancelEnrollment = async () => {
    try {
      // First get the user program to find its invoiceId
      const programData = await get(`/UserPrograms/${mainId}`);
      if (programData?.data?.invoiceId) {
          // Delete the associated invoice to prevent orphaned records
          await remove(`/Invoices/${programData.data.invoiceId}`);
      }

      // Completely delete the enrollment record from database
      const response = await remove(`/UserPrograms/${mainId}`);

      if (response.statusCode === 200) {
        
        setSnackbarMessage("Enrollment deleted successfully!");
        setSnackbarOpen(true);
        if (onSuccess) onSuccess();
        setTimeout(() => {
          onClose();
        }, 1000);
      } else {
        console.error("Error:", response.message);
        setSnackbarMessage("Failed to delete enrollment. Please try again.");
        onClose();
      }
    } catch (error) {
      console.error("Error:", error);
      setSnackbarMessage("An error occurred. Please try again.");
    }
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="confirm-dialog-title"
        aria-describedby="confirm-dialog-description"
      >
        <DialogTitle id="confirm-dialog-title">{"Delete Enrollment"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="confirm-dialog-description">
            Are you sure you want to completely delete this enrollment record and its associated invoice?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="default" variant="outlined" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleCancelEnrollment}
            color="secondary"
            autoFocus
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
      />
    </>
  );
};

export default CancelEnrollment;
